import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import { Pannellum } from "pannellum-react";
import Dropzone from 'react-dropzone'
import { withTheme } from '@material-ui/core/styles'

// import other components within the same project here
import Config from "../../Config.jsx";

import Helper from "../../Helper.jsx"

import {
  Button,
  Icon,
  Typography,
  Tooltip,
} from '@material-ui/core';

import { grey } from '@material-ui/core/colors';
import AndroidIcon from '@material-ui/icons/Android';
import Localization from '../../Localization';
import AIGenerateDialog from '../AIGenerateDialog.jsx';

class StageMediaImage extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      currentPitch: 0,
      currentYaw: 0,
      currentHFOV: 100,
      aiGenerateDialogOpen: false,
    };
    autoBind(this);
  }

  handleAIGenerateClick() {
    this.refs.aiGenerateDialog.handleOpen();
  }

  handleMouseUp() {
    let viewer = this.refs.panImage.getViewer();
    this.setState({
      currentPitch: viewer.getPitch(),
      currentYaw: viewer.getYaw(),
      currentHFOV: viewer.getHfov(),
    })
    this.state.currentPitch = viewer.getPitch();
    this.state.currentYaw = viewer.getYaw();
    this.state.currentHFOV = viewer.getHfov();
  }

  uploadClicked() {
    this.props.root.refs.stageViewerPage.uploadFile();
  }

  lookAt(pitch, yaw) {
    if (this.refs.panImage) {
      let viewer = this.refs.panImage.getViewer();
      viewer.lookAt(pitch, yaw);

      this.setState({
        currentPitch: pitch,
        currentYaw: yaw,
        currentHFOV: viewer.getHfov(),
      })
      this.state.currentPitch = pitch;
      this.state.currentYaw = yaw;
      this.state.currentHFOV = viewer.getHfov();
    }
  }

  render() {
    let quality = this.props.parent.state.imageQuality;
    let path = "path";
    if (quality == this.props.parent.IMAGE_QUALITY_FAST()) {
      path = "tn_path";
    }

    let fileUrl = "";
    let playbackHotspot = [];
    if (this.props.stageData) {
      if (this.props.stageData['movie_list'].length > 0) {
        let movieData = this.props.stageData['movie_list'][0];
        fileUrl = Config.BASE_PATH() + movieData[path];
      }
      for (let i = 0; i < this.props.stageData['playback_list'].length; i++) {
        let playbackData = this.props.stageData['playback_list'][i];
        let kind = parseInt(playbackData['kind']);
        let showHotspotAtThisMoment = this.props.parent.state.playbackTime >= parseInt(playbackData['trigger_time']) && this.props.parent.state.playbackTime <= (parseInt(playbackData['trigger_time']) + parseInt(playbackData['countdown_limit']));
        if (Config.GET_PLAYBACK_CONFIG(kind)['hasPosition'] && showHotspotAtThisMoment) {
          let hotspotPosition = Helper.convertXYtoYawPitch(parseFloat(playbackData.pos_x), parseFloat(playbackData.pos_y));
          playbackHotspot.push(
            {
              id: playbackData['id'],
              pitch: hotspotPosition.pitch,
              yaw: hotspotPosition.yaw,
              text: Config.GET_PLAYBACK_CONFIG(kind)['name'] + "\n" + Helper.fToHHMMSS(playbackData['trigger_time']) + "\n" + playbackData['content'],
            }
          );
        }
      }
    }

    let is360View = true;
    if (this.props.parent.refs.imageHolder) {
      is360View = this.props.parent.refs.imageHolder.state.is360View;
    }

    let mediaHeight = this.props.maxHeight - (this.props.parent.props.parent.state.imageHolderHeight + this.props.parent.props.parent.state.stageElementListViewHeight);
    let aiGenerateDisabled = !this.props.aiGenerateEnabled;
    let aiGenerateTooltip = Localization.strings.AI_GENERATE_QUOTA_TOOLTIP;
    let aiGenerateQuotaTotal = parseInt(this.props.aiGenerateQuotaTotal || 0);
    let aiGenerateLabel = Localization.strings.AI_GENERATE_BY_AI;
    if (!isNaN(aiGenerateQuotaTotal)) {
      aiGenerateLabel = `${aiGenerateLabel} (Remaining Quota: ${aiGenerateQuotaTotal})`;
    }

    return (
      <div style={{height:mediaHeight}} ref="div">
        <If condition={fileUrl == ""}>
          <Then>
            <div style={{width:'100%', height:'100%', backgroundColor:grey[300]}}>
              <Dropzone onDrop={acceptedFiles => this.props.parent.props.parent.props.parent.onFileDrop(acceptedFiles)}>
                {({getRootProps, getInputProps}) => (
                    <div style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', textAlign:'center'}} {...getRootProps()}>
                      <input {...getInputProps()} />
                      <div>
                        <div style={{color:this.props.theme.palette.primary.main, fontWeight:'bold'}}>
                          {Localization.strings.FILEPICKER_MESSAGE}
                        </div>
                        <br/>
                        {Localization.strings.SUPPORTED_FILE_TYPE} {Config.GET_ALLOWED_FILE_EXTENSION("image").replace(/,/g, " / ")}
                        <If condition={this.props.showAIGeneration}>
                          <div>
                            <br/>
                            <Tooltip
                              title={aiGenerateDisabled ? aiGenerateTooltip : ""}
                              disableHoverListener={!aiGenerateDisabled}
                            >
                              <span>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  className="margin-sm"
                                  startIcon={<AndroidIcon />}
                                  disabled={aiGenerateDisabled}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.handleAIGenerateClick();
                                  }}
                                >
                                  {aiGenerateLabel}
                                </Button>
                              </span>
                            </Tooltip>
                          </div>
                        </If>
                      </div>
                    </div>
                )}
              </Dropzone>
            </div>
          </Then>
          <Else>
            <If condition={is360View}>
              <Then>
                <Pannellum
                  ref="panImage"
                  width="100%"
                  height="100%"
                  image={fileUrl}
                  pitch={this.state.currentPitch}
                  yaw={this.state.currentYaw}
                  hfov={this.state.currentHFOV}
                  autoLoad
                  onMouseup={()=>this.handleMouseUp()}
                >
                  {playbackHotspot.map((playback, i)=>{
                    return (
                      <Pannellum.Hotspot
                        key={i}
                        type="info"
                        pitch={playback.pitch}
                        yaw={playback.yaw}
                        text={playback.text}
                      />
                    );
                  })}
                </Pannellum>
              </Then>
              <Else>
                <img
                  src={fileUrl}
                  style={{objectFit:'contain', margin:"auto", width:'100%', height:'100%', backgroundColor:'Black'}}
                />
              </Else>
            </If>
          </Else>
        </If>
        <AIGenerateDialog parent={this} root={this.props.root} ref="aiGenerateDialog" localeData={this.props.localeData} stageData={this.props.stageData} onUploadSuccess={this.props.onUploadSuccess} />
      </div>
    )
  }
}

export default withTheme(StageMediaImage);
